/**
 * One action-inbox row. Shared by the Overview card and the /action-inbox page
 * so a task looks and behaves the same wherever it is surfaced.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from './Icons';
import { Badge } from './ui';
import { useT } from '../../i18n';

export function TaskRow({ task }) {
  const navigate = useNavigate();
  const { t } = useT();
  const Ic = X[task.icon] || X.Info;
  const scopeVars = task.titleVars && task.titleVars.scope === null
    ? { ...task.titleVars, scope: t('inbox.task.oneScope') }
    : task.titleVars;

  return (
    <div
      className="k2-task"
      role="link"
      tabIndex={0}
      onClick={() => navigate(task.to)}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(task.to); } }}
      title={task.actionKey ? `${t(task.actionKey)} →` : undefined}
    >
      <span className={`k2-ic k2-${task.tone}`}><Ic s={15} /></span>
      <span className="k2-tx">
        <span className="k2-a">{t(task.titleKey, scopeVars)}</span>
        <span className="k2-b2">{t(task.bodyKey, task.bodyVars)}</span>
      </span>
      {task.badge && <Badge tone={task.tone === 'e' ? 'err' : 'warn'}>{task.badge}</Badge>}
      <span className="k2-go"><X.Chev s={15} /></span>
    </div>
  );
}

export default TaskRow;
